import { ArrowRight, Trees, MapPin, Mountain } from "lucide-react";
import PhotoFrame from "./PhotoFrame";

export default function Hero({ image }) {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-7">
              <span className="h-px w-10 bg-[#985F47]" />
              <span className="text-[11px] uppercase tracking-[0.35em] text-[#985F47]">Dehradun · Foothills of Mussoorie</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="serif text-[40px] sm:text-[54px] md:text-[68px] lg:text-[82px] leading-[0.98] tracking-tightest text-[#2C392F] font-light"
            >
              A quieter way to stay
              <br />
              <span className="italic font-normal text-[#985F47]">at the foothills</span> of Mussoorie.
            </h1>

            <p className="mt-8 max-w-xl text-[#4A4D4A] text-base md:text-lg leading-relaxed">
              A spacious, fully serviced Dehradun home with open lawns, orchard trees and evening views
              of Mussoorie glittering in the distance.
            </p>

            {/* Mussoorie hero badge */}
            <div
              data-testid="hero-mussoorie-badge"
              className="mt-8 inline-flex flex-wrap items-center gap-x-5 gap-y-2 bg-[#2C392F]/[0.04] border border-[#2C392F]/15 rounded-full pl-4 pr-5 py-2.5"
            >
              <span className="inline-flex items-center gap-2 text-[12px] text-[#2C392F]">
                <Mountain size={14} className="text-[#985F47]" strokeWidth={1.6} />
                <span className="tracking-wide">Mussoorie views</span>
              </span>
              <span className="hidden sm:inline text-[#985F47]/40">·</span>
              <span className="inline-flex items-center gap-2 text-[12px] text-[#2C392F]">
                <MapPin size={14} className="text-[#985F47]" strokeWidth={1.6} />
                <span className="tracking-wide">21 km to Mussoorie</span>
              </span>
              <span className="hidden sm:inline text-[#985F47]/40">·</span>
              <span className="text-[12px] text-[#2C392F] tracking-wide">
                Approx. 45-minute drive
              </span>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <button
                data-testid="cta-button-hero-enquire"
                onClick={() => go("enquire")}
                className="inline-flex items-center gap-2 bg-[#2C392F] text-[#F7F5F0] hover:bg-[#1E2823] px-7 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all shadow-sm hover:shadow-md"
              >
                Enquire About Your Stay <ArrowRight size={16} />
              </button>
              <button
                data-testid="cta-button-hero-explore"
                onClick={() => go("house")}
                className="inline-flex items-center gap-2 border border-[#2C392F]/30 text-[#2C392F] hover:bg-[#2C392F] hover:text-[#F7F5F0] px-7 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all"
              >
                Explore the House
              </button>
            </div>

            <p className="mt-7 text-[13px] text-[#4A4D4A] italic serif">
              Ideal for relaxed staycations, family visits, work-from-anywhere breaks and extended stays.
            </p>
          </div>

          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <PhotoFrame
                image={image}
                placeholderLabel="The orchard at first light"
                placeholderCaption="Hero photograph"
                placeholderIcon={Trees}
                ratio="aspect-[4/5]"
              />
              <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#F7F5F0] border border-[#2C392F]/10 rounded-2xl px-5 py-4 shadow-sm">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47] mb-1">Est.</div>
                <div className="serif text-2xl text-[#2C392F]">A private home, fully serviced</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute top-1/2 -right-32 h-[420px] w-[420px] rounded-full bg-[#6A7B61]/10 blur-3xl" />
    </section>
  );
}
